<script setup lang="ts">
import { useRouter } from "vue-router";
import VInlineButton from "@magnit/core/src/components/VInlineButton/VInlineButton.vue";
import VIcon from "@magnit/icons/src/components/VIcon/VIcon.vue";

interface IPageBackProps {
  route?: string;
  text?: string;
}

const props = defineProps<IPageBackProps>();
const router = useRouter();

const onClick = () => {
  if (props.route) {
    router.push(props.route);
  } else {
    router.back();
    window.scrollTo(0, 0);
  }
};
</script>

<template>
  <div class="page-back">
    <VInlineButton
      class="page-back__button"
      :class="{ 'page-back__button_only-icon': !text }"
      :icon-position="text ? 'left' : undefined"
      @click="onClick"
    >
      <template #icon>
        <VIcon name="24-outline-left-corner" />
      </template>

      <template v-if="text">
        {{ text }}
      </template>
    </VInlineButton>
  </div>
</template>

<style lang="postcss">
.page-back {
  padding: 4px 0;

  & &__button {
    margin-left: -6px;

    &_only-icon {
      margin-left: -16px;
    }
  }
}
</style>
